<template>
  <div class="register-page">
    <div class="register-card">
      <h2 class="title">註冊帳號</h2>

      <!-- 身分類別 -->
      <label class="label">身分類別</label>
      <div class="input-box">
        <select v-model="role" class="role-select" required @change="resetForm">
          <option disabled value="">請選擇身分類別</option>
          <option value="User">一般會員</option>
          <option value="Supplier">經銷商</option>
          <option value="DrugStore">藥局</option>
          <option value="Doctor">獸醫師</option>
        </select>
      </div>

      <form v-if="role" @submit.prevent="handleRegister" class="grid-form">
        <!-- 一般會員 -->
        <template v-if="role === 'User'">
          <div class="form-row">
            <div class="form-input-wrapper">
              <label class="form-input-label">姓名</label>
              <div class="form-input-box">
                <input
                  v-model="form.name"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入您的姓名"
                  required
                />
              </div>
            </div>

            <div class="form-input-wrapper">
              <label class="form-input-label">電話</label>
              <div class="form-input-box">
                <input
                  v-model="form.phone"
                  type="tel"
                  class="form-input-field"
                  placeholder="請輸入您的連絡電話"
                  required
                />
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-input-wrapper full-width">
              <label class="form-input-label">電子郵件</label>
              <div class="form-input-box">
                <input
                  v-model="form.email"
                  type="email"
                  class="form-input-field"
                  placeholder="請輸入您的電子郵件"
                  required
                />
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-input-wrapper full-width">
              <label class="form-input-label">居住地址</label>
              <div class="form-input-box">
                <input
                  v-model="form.address"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入您的完整地址"
                  required
                />
              </div>
            </div>
          </div>
        </template>

        <!-- 經銷商 -->
        <template v-if="role === 'Supplier'">
          <div class="form-row">
            <div class="form-input-wrapper">
              <label class="form-input-label">公司名稱</label>
              <div class="form-input-box">
                <input
                  v-model="form.company"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入公司名稱"
                  required
                />
              </div>
            </div>

            <div class="form-input-wrapper">
              <label class="form-input-label">聯絡人姓名</label>
              <div class="form-input-box">
                <input
                  v-model="form.name"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入聯絡人姓名"
                  required
                />
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-input-wrapper">
              <label class="form-input-label">職稱</label>
              <div class="form-input-box">
                <input
                  v-model="form.title"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入職稱"
                />
              </div>
            </div>

            <div class="form-input-wrapper">
              <label class="form-input-label">連絡電話</label>
              <div class="form-input-box">
                <input
                  v-model="form.phone"
                  type="tel"
                  class="form-input-field"
                  placeholder="請輸入連絡電話"
                  required
                />
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-input-wrapper full-width">
              <label class="form-input-label">公司地址</label>
              <div class="form-input-box">
                <input
                  v-model="form.address"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入公司完整地址"
                  required
                />
              </div>
            </div>
          </div>
        </template>

        <!-- 藥局 -->
        <template v-if="role === 'DrugStore'">
          <div class="form-row">
            <div class="form-input-wrapper">
              <label class="form-input-label">公司名稱</label>
              <div class="form-input-box">
                <input
                  v-model="form.company"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入公司名稱"
                  required
                />
              </div>
            </div>

            <div class="form-input-wrapper">
              <label class="form-input-label">聯絡人姓名</label>
              <div class="form-input-box">
                <input
                  v-model="form.name"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入聯絡人姓名"
                  required
                />
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-input-wrapper">
              <label class="form-input-label">職稱</label>
              <div class="form-input-box">
                <input
                  v-model="form.title"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入職稱"
                />
              </div>
            </div>

            <div class="form-input-wrapper">
              <label class="form-input-label">連絡電話</label>
              <div class="form-input-box">
                <input
                  v-model="form.phone"
                  type="tel"
                  class="form-input-field"
                  placeholder="請輸入連絡電話"
                  required
                />
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-input-wrapper full-width">
              <label class="form-input-label">公司地址</label>
              <div class="form-input-box">
                <input
                  v-model="form.address"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入公司完整地址"
                  required
                />
              </div>
            </div>
          </div>
        </template>

        <!-- 獸醫師 -->
        <template v-if="role === 'Doctor'">
          <div class="form-row">
            <div class="form-input-wrapper">
              <label class="form-input-label">醫院名稱</label>
              <div class="form-input-box">
                <input
                  v-model="form.hospital"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入醫院名稱"
                  required
                />
              </div>
            </div>

            <div class="form-input-wrapper">
              <label class="form-input-label">醫師姓名</label>
              <div class="form-input-box">
                <input
                  v-model="form.name"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入醫師姓名"
                  required
                />
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-input-wrapper">
              <label class="form-input-label">職稱</label>
              <div class="form-input-box">
                <input
                  v-model="form.title"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入職稱"
                />
              </div>
            </div>

            <div class="form-input-wrapper">
              <label class="form-input-label">連絡電話</label>
              <div class="form-input-box">
                <input
                  v-model="form.phone"
                  type="tel"
                  class="form-input-field"
                  placeholder="請輸入連絡電話"
                  required
                />
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-input-wrapper full-width">
              <label class="form-input-label">醫院地址</label>
              <div class="form-input-box">
                <input
                  v-model="form.address"
                  type="text"
                  class="form-input-field"
                  placeholder="請輸入醫院完整地址"
                  required
                />
              </div>
            </div>
          </div>
        </template>

        <!-- 共用欄位:Email 和密碼 (僅針對非會員) -->
        <template v-if="role !== 'User'">
          <div class="form-row">
            <div class="form-input-wrapper full-width">
              <label class="form-input-label">電子郵件</label>
              <div class="form-input-box">
                <input
                  v-model="form.email"
                  type="email"
                  class="form-input-field"
                  placeholder="請輸入您的電子郵件"
                  required
                />
              </div>
            </div>
          </div>
        </template>

        <div class="form-row">
          <div class="form-input-wrapper">
            <label class="form-input-label">密碼</label>
            <div class="form-input-box">
              <input
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                class="form-input-field"
                placeholder="請輸入登入密碼"
                required
              />
              <img
                class="form-input-toggle"
                :src="showPassword ? showIcon : unshowIcon"
                @click="showPassword = !showPassword"
              />
            </div>
          </div>

          <div class="form-input-wrapper">
            <label class="form-input-label">確認密碼</label>
            <div class="form-input-box">
              <input
                v-model="form.confirm"
                :type="showConfirmPassword ? 'text' : 'password'"
                class="form-input-field"
                placeholder="請再次輸入密碼確認"
                required
              />
              <img
                class="form-input-toggle"
                :src="showConfirmPassword ? showIcon : unshowIcon"
                @click="showConfirmPassword = !showConfirmPassword"
              />
            </div>
          </div>
        </div>

        <button type="submit" class="register-btn">註冊</button>

        <div class="links">
          <router-link to="/login">返回登入</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script src="@/assets/js/register.js"  defer></script>
<style src="@/assets/css/register.css"></style>
